import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Checkbox from "@material-ui/core/Checkbox";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const AlertDialogSlide = ({ onGDPRApproval, gDPRApproved }) => {
  const [open, setOpen] = React.useState(false);
  const [bottom, setBottom] = React.useState(true);

  const handleScroll = (e) => {
    const scrollPositionIsAtBottom =
      e.target.scrollHeight >
      Math.ceil(e.target.scrollTop) + e.target.clientHeight;
    setBottom(scrollPositionIsAtBottom);
  };

  const handleClickOpen = () => {
    if (gDPRApproved) {
      onGDPRApproval();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onApproved = () => {
    setOpen(false);
    onGDPRApproval();
  };

  return (
    <div>
      <span>
        <Checkbox
          {...label}
          onClick={handleClickOpen}
          checked={gDPRApproved}
          value={gDPRApproved}
        />
        I accept the Terms of Service and Privacy Policy
      </span>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Privacy policy"}</DialogTitle>
        <DialogContent onScroll={handleScroll}>
          <DialogContentText id="alert-dialog-slide-description">
            {`Under the General Data Protection Regulation (GDPR) (EU), we have a legal duty to protect any information we collect from you.
            Drakryggen is committed to ensuring the security and protection of the personal information that we process,
            and to provide a compliant and consistent approach to data protection.
            We only use cookies to enhance the user experience, in practice to keep track of that you are logged in.             
            If you have any questions related to our GDPR compliance or other compliance issues, please contact gdpr@drakryggen.com
          `}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={onApproved} /* disabled={bottom} */>Agree</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialogSlide;
